<template>
    <div
        v-show="show"
        class="io-loading-overlay"
    >
        <div>
            <i class="fas fa-spinner fa-pulse"></i>
            <template
                v-if="text"
            >
                <br>
                <span
                    v-html="text"
                ></span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    text: {
      type: String,
      required: false,
      default: () => null,
    },
  },
};
</script>

<style lang="scss">
    .io-loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, .675);
        z-index: 10;

        > div {
            position: absolute;
            top: 50%;
            left: 50%;
            width: auto;
            height: auto;
            transform: translateX(-50%) translateY(-50%);
            font-size: 40px;
            text-align: center;

            > span {
                font-size: 20px;
                margin-top: 1em;
                font-weight: 400;
                display: inline-block;
            }
        }

        .card > &, .card > .card-body & {
            border-radius: 20px !important;
        }
    }
</style>
